import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { GroupHeaderLoadFulfilledAction } from '../../domains/groupHeaderLoad/actions.types';
import { GroupEditFulfilledAction } from '../../domains/groups/editActions.types';

export type GroupFeaturePermissionsAction = GroupHeaderLoadFulfilledAction | GroupEditFulfilledAction;

const initialState: GroupFeaturePermissions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

import { GroupFeaturePermissions } from './types';

const reducer: Reducer<GroupFeaturePermissions, GroupFeaturePermissionsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_HEADER.LOAD_FULFILLED':
    case 'GROUP.EDIT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupFeaturePermissions);
    default:
      return state;
  }
};

export default reducer;
